(() => {
  if (customElements.get('featured-collections-slider')) {
    return;
  }

  class FeaturedCollectionsSlider extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.options = {};
      this.spacingDesktop = Number(this.dataset.spacingDesktop) || 30;
      this.spacingMobile = Number(this.dataset.spacingMobile) || 30;
      this.slidesDesktop = Number(this.dataset.slidesDesktop) || 5;
      this.centerSlides = this.dataset.centerSlides === 'true' ? true : false;
      this.showPagination = this.dataset.showPagination === 'true' ? true : false;
      this.slidesPerGroup = Number(this.dataset.slidesPerGroup) || 1;
      this.loop = this.dataset.loop === 'true' ? true : false;
      this.resizeTimeout = null;
      this.handleResize = this.handleResize.bind(this);

      if (!this.loop) {
        this.centerSlides = false;
      }
    }

    connectedCallback() {
      this.initSlider();
      this.updateMediaHeightCSSVariable();
      window.addEventListener('resize', this.handleResize);
    }

    disconnectedCallback() {
      if (this.resizeTimeout) {
        clearTimeout(this.resizeTimeout);
      }
      window.removeEventListener('resize', this.handleResize);
    }

    handleResize() {
      if (this.resizeTimeout) {
        clearTimeout(this.resizeTimeout);
      }
      this.resizeTimeout = setTimeout(() => {
        this.updateMediaHeightCSSVariable();
      }, 150);
    }

    updateMediaHeightCSSVariable() {
      const cardProducts = this.querySelectorAll('card-product');
      let halfHeight = '50%'; // Default value

      // Find the first card-product with a .media element
      if (cardProducts && cardProducts.length > 0) {
        for (const cardProduct of cardProducts) {
          const mediaElement = cardProduct.querySelector('.media');
          if (mediaElement && mediaElement.offsetHeight > 0) {
            const height = mediaElement.offsetHeight;
            halfHeight = `${height / 2}px`;
            break;
          }
        }
      }

      // Always set the CSS variable on the component root so it's accessible to all child elements
      this.style.setProperty('--media-half-height', halfHeight);
    }

    updateFirstSlideClass() {
      if (!this.centerSlides) return;
      const sliderElement = this.querySelector('[data-slider]');
      if (!sliderElement) return;

      // Remove the class from all slides
      const allSlides = sliderElement.querySelectorAll('.swiper-slide');
      allSlides.forEach((slide) => {
        slide.classList.remove('swiper-slide-first');
      });

      // Find the slide with swiper-slide-prev class
      const prevSlide = sliderElement.querySelector('.swiper-slide-prev');
      if (prevSlide) {
        // Find the previous sibling slide
        const firstSlide = prevSlide.previousElementSibling;
        if (firstSlide && firstSlide.classList.contains('swiper-slide')) {
          firstSlide.classList.add('swiper-slide-first');
        }
      }
    }

    initSlider() {
      const sliderElement = this.querySelector('[data-slider]');
      if (!sliderElement) return;

      this.options = {
        slidesPerView: 'auto',
        spaceBetween: this.spacingMobile,
        loop: this.loop,
        speed: 500,
        centeredSlides: this.centerSlides,
        centerInsufficientSlides: true,
        centeredSlidesBounds: true,
        navigation: {
          prevEl: this.querySelector('.swiper-arrow--prev'),
          nextEl: this.querySelector('.swiper-arrow--next'),
        },
        pagination: this.showPagination ? {
          el: this.querySelector('.swiper-pagination'),
          clickable: true,
        } : false,
        breakpoints: {
          750: {
            spaceBetween: this.spacingDesktop,
          },
        },
        on: {
          init: () => {
            this.updateFirstSlideClass();
            this.updateMediaHeightCSSVariable();
          },
          slideChange: () => {
            this.updateFirstSlideClass();
          },
          slideChangeTransitionStart: () => {
            this.updateFirstSlideClass();
          },
          slideChangeTransitionEnd: () => {
            this.updateFirstSlideClass();
          },
        },
      };

      // Only apply slidesPerGroup if pagination is enabled
      if (this.showPagination && this.slidesPerGroup > 1) {
        this.options.slidesPerGroup = this.slidesPerGroup;
        this.options.breakpoints[750].slidesPerGroup = this.slidesPerGroup;
      }

      this.slider = new Swiper(sliderElement, this.options);
    }
  }

  customElements.define('featured-collections-slider', FeaturedCollectionsSlider);
})();

